import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { SessionStorageService } from 'src/app/shared/services/session-storage.service';
import { createOrg } from 'src/app/shared/models/organizations';
import { OrganizationsService } from 'src/app/shared/services/organizations.service';
@Component({
  selector: 'app-create-organization',
  templateUrl: './create-organization.component.html',
  styleUrls: ['./create-organization.component.scss']
})
export class CreateOrganizationComponent implements OnInit {
  createOrgForm = new FormGroup({
    orgType: new FormControl('', [Validators.required]),
    orgName: new FormControl('', [Validators.required]),
    isDataCaptureEnabled: new FormControl(false),
    isDataVisualizationEnabled: new FormControl(false),
  })
  dropdownOptions: string[] = ['GROK', 'SCHOOL', 'COLLEGE', 'INDUSTRY'];
  isSuperAdmin: boolean = false;
  isLoading: boolean = false;
  outline: boolean = false;
  outlineOrgType = false;
  outlineOrgName = false;
  currentUser: any;
  constructor(
    private router: Router,
    private toasterService: ToastrService,
    private sessionStorageService: SessionStorageService,
    private organizationService: OrganizationsService
  ) {
    this.isSuperAdmin = window.location.href.includes('/admin/');
  }

  ngOnInit(): void {
    this.currentUser = this.sessionStorageService.getUsername();
  }

  onFocus(field: string) {
    if (field === 'orgType') {
      this.outlineOrgType = false;
    } else if (field === 'orgName') {
      this.outlineOrgName = false;
    }
  }

  async onSubmit() {
    this.outlineOrgType = this.createOrgForm.get('orgType').invalid;
    this.outlineOrgName = this.createOrgForm.get('orgName').invalid;
    
    const controls = this.createOrgForm.controls;
    console.log(controls['orgType'].value);
    console.log(controls['orgName'].value);
    console.log(controls['isDataCaptureEnabled'].value);
    console.log(controls['isDataVisualizationEnabled'].value);
    if (!this.createOrgForm.invalid) {
      try {
        const payload: createOrg = {
          organizationName: controls['orgName'].value.trim(),
          organizationType: controls['orgType'].value,
          userName: this.currentUser,
          isDataCaptureEnabled: controls['isDataCaptureEnabled'].value,
          isDataVisualizationEnabled: controls['isDataVisualizationEnabled'].value,
        };
        this.isLoading = true;
        const result: any = await this.organizationService.create(payload).toPromise();
        if (result['success'] == true) {
          this.toasterService.success("Organization created successfully");
          this.onCancel();
          this.isLoading = false;
        }
      }
      catch (err: any) {
        this.isLoading = false;
        if (err.status == 403) {
          console.log(err);
        }
        else {
          this.toasterService.error(`${err.error.message}`);
        }
      }
    }
  }
  
  onCancel() {
    if (this.isSuperAdmin) {
      this.router.navigateByUrl('/admin/organizations');
    } else {
      this.router.navigateByUrl('/ide/labs');
    }
  }
}